<template>
  <div>
    <p class="body__normal-medium">
      Cellular Parameters
    </p>

    <div v-if="isLoading">
      <p class="ring-card__input-label">
        Loading <i class="el-icon-loading" />
      </p>
      <div class="main-container__icon__loader"></div>
    </div>

    <div v-else-if="error">
      <p class="error">
        Error while getting cellular parameters.
      </p>
    </div>

    <div v-else>
      <div class="ring-card__input-label">
        Imei
      </div>
      <p class="ring-card__input">
        {{ data["imei"] }}
      </p>

      <div
          v-if="previousImei"
          class="ring-card__input-label">
        Previous imei
      </div>
      <p
          v-if="previousImei"
          class="ring-card__input">
        {{ previousImei }}
      </p>

      <div class="ring-card__input-label">
        Eid
      </div>
      <p class="ring-card__input">
        {{ data["eid"] }}
      </p>

      <div class="ring-card__input-label">
        Iccid
      </div>
      <p class="ring-card__input">
        {{ data["iccid"] }}
      </p>

      <div
          v-if="previousIccIds"
          class="ring-card__input-label">
        Previous iccids
      </div>
      <p
          v-if="previousIccIds"
          class="ring-card__input">
        {{ previousIccIds }}
      </p>
    </div>
  </div>
</template>

<script>
import { get } from "lodash";

export default {
  name: "CellularData",
  props: {
    doorbotId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      data: undefined,
      isLoading: true,
      error: undefined,
    };
  },
  computed: {
    previousIccIds() {
      if (
        this.data["previous_iccids"] === undefined ||
        this.data["previous_iccids"].length === 0
      ) {
        return undefined;
      }

      return this.data["previous_iccids"].join(", ");
    },
    previousImei() {
      if (this.data["previous_imei"] === undefined) {
        return undefined;
      }

      return this.data["previous_imei"];
    },
  },
  mounted() {
    this.connectWebSocket();
    this.subscribeToCellularParametersChannel();
  },
  methods: {
    connectWebSocket() {
      const token = localStorage.getItem("@token_id");
      this.$cable.connection.connect(
        `wss://${new URL(process.env.API_URL).host}/cable?token=${token}&app=ND`
      );
    },
    subscribeToCellularParametersChannel() {
      this.$cable.subscribe({
        channel: "CellularParametersChannel",
        id: this.doorbotId,
      });
    },
    endWebsocketSession() {
      this.$cable.unsubscribe("CellularParametersChannel");
      this.$cable.connection.disconnect();
    },
    requestCellularParameters() {
      this.error = undefined;
      this.isLoading = true;
      this.$cable.perform({
        channel: "CellularParametersChannel",
        action: "get_cellular_parameters",
        data: {
          id: this.doorbotId,
        },
      });
    },
  },
  channels: {
    CellularParametersChannel: {
      connected() {
        this.requestCellularParameters();
      },
      rejected() {
        this.isLoading = false;
      },
      received(response) {
        this.isLoading = false;
        if (response.code !== 200) {
          console.log(
            `Cellular Parameters fetch error: ${JSON.stringify(response)}`
          );
          this.error = get(response, "message", "Unknown error");
          return;
        }

        this.data = response.data;
        this.endWebsocketSession();
      },
      disconnected() {
        this.isLoading = false;
      },
    },
  },
};
</script>

<style scoped>
.ring-card__input {
  margin-top: 0px;
}
.error {
  color: #d4231a;
}
</style>
